import { createFileRoute } from "@tanstack/react-router";
import LegalPage from "@/components/LegalPage";
import { buildHead, breadcrumbLD } from "@/content/seo";

const TITLE = "Termos e Condições · Morningstar Yacht · Vilamoura";
const DESC = "Termos e condições dos charters privados a bordo do Morningstar a partir da Marina de Vilamoura — reservas, cancelamentos, política meteorológica, responsabilidade e arbitragem de consumo.";
const PATH = "/pt/termos";

export const Route = createFileRoute("/pt/termos")({
  component: () => (
    <LegalPage
      lang="pt"
      title="Termos e Condições"
      updated="Maio 2026"
      homeHref="/pt"
      backLabel="Voltar à página inicial"
      intro="Estes Termos e Condições regem a utilização dos serviços prestados pela Luxury Reference, Lda., operando como Vilamoura Dreams Cruises / Morningstar Yacht (RNAAT n.º 743/2022)."
      sections={[
        {
          heading: "Reservas",
          body: [
            "Todas as reservas estão sujeitas a disponibilidade e são confirmadas pelo nosso concierge após receção do pagamento. Os preços são por charter de iate (até 18 convidados).",
          ],
        },
        {
          heading: "Cancelamentos e Meteorologia",
          body: [
            "Cancelamentos efetuados pelo cliente com mais de 14 dias de antecedência são totalmente reembolsáveis. Cruzeiros cancelados por motivos meteorológicos serão remarcados ou totalmente reembolsados.",
          ],
        },
        {
          heading: "Responsabilidade",
          body: [
            "Todos os passageiros devem seguir as instruções de segurança fornecidas pela tripulação. O operador está totalmente segurado ao abrigo da regulamentação portuguesa RNAAT.",
          ],
        },
        {
          heading: "Resolução Alternativa de Litígios de Consumo",
          body: [
            'Em caso de litígio de consumo, o cliente pode recorrer à entidade oficial de Resolução Alternativa de Litígios de Consumo competente para a região do Algarve: <strong>CIMAAL — Centro de Informação, Mediação e Arbitragem de Conflitos de Consumo do Algarve</strong>. Mais informações em <a class="underline hover:text-gold" href="https://www.consumoalgarve.pt/index.php/pt/" target="_blank" rel="noopener noreferrer">www.consumoalgarve.pt</a>.',
            'Mais informações sobre direitos do consumidor disponíveis no Portal do Consumidor: <a class="underline hover:text-gold" href="https://www.consumidor.gov.pt/" target="_blank" rel="noopener noreferrer">www.consumidor.gov.pt</a>.',
          ],
        },
        {
          heading: "Contacto",
          body: [
            'Para qualquer questão sobre estes termos, contacte-nos em <a class="underline hover:text-gold" href="mailto:info@vilamouradreamscruises.com">info@vilamouradreamscruises.com</a>.',
          ],
        },
      ]}
    />
  ),
  head: () =>
    buildHead({
      lang: "pt",
      path: PATH,
      title: TITLE,
      description: DESC,
      altPath: { en: "/terms", pt: PATH },
      extraScripts: [
        {
          type: "application/ld+json",
          children: JSON.stringify(
            breadcrumbLD([
              { name: "Início", path: "/pt" },
              { name: "Termos e Condições", path: PATH },
            ]),
          ),
        },
      ],
    }),
});